import React from "react";
import PropTypes from "prop-types";
import { Card } from "primereact/card";
import ArrowRight from "../../../../Assets/Property 1=Arrow Right.png";
import ActiveDotImage from "../../../../Assets/greendot.png";
import InactiveDotImage from "../../../../Assets/reddot.png";
import * as dashboardselector from "../../../../Store/Dashboard/DashboardSelectors";
import "./TotalActiveInactiveAshaAnm.scss";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const TotalActiveInactiveAshaAnm = ({
  status,
  title,
  ashaanmDetails,
  ashaModal,
  totalCount,
  ashaCount,
  anmCount,
  afCount,
}) => {
  const isActive = status === 'active';
  const areaType = useSelector(dashboardselector.getGlobalAreaType);
  const dotImage = isActive ? ActiveDotImage : InactiveDotImage;
  const { t } = useTranslation();
  return (
    <>
      <div
        className="flex flex-column lg:gap-2 sm:gap-5 ml-2 bg-white p-3 total-asha-detail"
        data-testid="container"
      >
        <div className="flex align-items-center justify-content-between">
          <div className="text-base text-blue-900 font-semibold total-asha-anm">
            <img
              className="dotClass"
              src={dotImage}
              alt=""
              data-testid="statusDot"
            />
            {t("total")} {title}
          </div>
          <div className="ml-5 total-asha-anm">
            <img
              className="arrow-right"
              src={ArrowRight}
              alt=""
              onClick={ashaanmDetails}
              onKeyDown={ashaanmDetails}
              data-testid="arrowRight"
            />
          </div>
        </div>
        <div
          className="text-sm text-blue-900 total-asha-anm-block"
          data-testid="totalCount"
        >
          <span
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {t("total")} {isActive ? t("active") : t("inactive")} {t("ANM")} & {t("ASHA")}
            {areaType === "Rural" || areaType === "ग्रामीण" ? <> & {t("AF")}</> : <></>}: {totalCount}
          </span>
          <div className="card">
            <Card
              className="card_asha_anm"
              onClick={() => ashaModal("asha", isActive ? 0 : 1)}
              data-testid="ashaCard"
            >
              {/* onClick={() => ashaModal('asha', isActive ? 0 : 1)} */}
              <div className="text-xs" data-testid="ashaLabel">
                {t("ASHA")}
              </div>
              <div
                className="text-blue-900 text-lg font-semibold"
                data-testid="ashaCount"
              >
                {ashaCount}
              </div>
            </Card>
            <Card
              className="card_asha-anm"
              data-testid="anmCard"
              onClick={() => ashaModal("anm", isActive ? 0 : 1)}
            >
              {/*  */}
              <div className="text-xs" data-testid="anmLabel">
                {t("ANM")}
              </div>
              <div
                className="text-center text-blue-900 text-lg font-semibold"
                data-testid="anmCount"
              >
                {anmCount}
              </div>
            </Card>
            {areaType === "Rural" || areaType === "ग्रामीण" ? (
              <Card
                className="card_asha-anm"
                data-testid="afCard"
                onClick={() =>
                  ashaModal("af", isActive ? 0 : 1)}
              >
                {/*  */}
                <div className="text-xs" data-testid="afLabel">
                  {t("AF")}
                </div>
                <div
                  className="text-center text-blue-900 text-lg font-semibold"
                  data-testid="afCount"
                >
                  {afCount}
                </div>
              </Card>
            ) : (<></>)}
          </div>
        </div>
      </div>
      <br></br>
    </>
  );
};

TotalActiveInactiveAshaAnm.propTypes = {
  title: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  status: PropTypes.oneOf(["active", "inactive"]).isRequired,
  ashaanmDetails: PropTypes.func.isRequired,
  activeList_asha: PropTypes.array.isRequired,
  activeList_anm: PropTypes.array.isRequired,
  activeList_af: PropTypes.array.isRequired,
};

export default TotalActiveInactiveAshaAnm;
